<template>

<app-wrapper>

	<com-transitions />
	<com-cta class="cta" />
	<app-wrapper>
	<com-section v-for="(section, index) in page.sections" :index="index" :key="index" :item="section" />
	</app-wrapper>
	<com-recent />

</app-wrapper>

</template>

<script>

import comTransitions from './../home/Transitions'
import comCTA from './../home/CTA'
import comSection from './landing/Section'
import comRecent from './../home/Recent'

export default {

	components: {
        'com-transitions': comTransitions,
        'com-cta': comCTA,
		'com-section': comSection,
        'com-recent': comRecent
	}

}

</script>

<style scoped>

.cta {
	margin-bottom: 16px!important;
}

</style>